import React from "react"
import ProgressiveImage from "react-progressive-image"
import styled from "styled-components"
import { ImageProps, ImageAspect } from "./image-types"

const LANDSCAPERATIO = 0.7
const SRCSETSIZES: number[] = [840, 1260, 1680, 2100, 2520, 3360]

const Img = styled.img`
  display: block;
`

const queryParams = (w: number, h: number): string => `?w=${w}&h=${h}&fit=fill&fm=jpg&q=90&fl=progressive`
const intrinsicWidth = (w: number): string => ` ${w}w`

function getSrcSet(srcRoot: string, aspect: ImageAspect): string {
  const queryParamsWidth: string[] = []

  SRCSETSIZES.forEach(width => {
    const height = aspect == ImageAspect.Square ? width : Math.round(width * LANDSCAPERATIO)
    queryParamsWidth.push(`${srcRoot}${queryParams(width, height)}${intrinsicWidth(width)}`)
  })

  return queryParamsWidth.reverse().join(", ")
}

export function getSizes(): string {
  const sizes: string[] = SRCSETSIZES.map((d, i) => {
    if (i == 0) {
      return `(max-width: ${d}px) ${d}px `
    } else {
      return `(min-width: ${SRCSETSIZES[i - 1]}) and (max-width: ${d}px) ${d}px `
    }
  })
  return sizes.join(", ")
}

export const ImageSrcSet: React.FC<ImageProps> = ({ src, aspect = ImageAspect.Landscape, alt, css }) => (
  <Img srcSet={getSrcSet(src, aspect)} sizes={getSizes()} src={src} alt={alt} css={css} />
)

export const ProgressiveImageSrcSet: React.FC<ImageProps & { small: string }> = ({
  src,
  small,
  aspect = ImageAspect.Landscape,
  alt,
  css
}) => (
  /* use new URL(...) to prevent server side rendering from injecting an absolute URL */
  <ProgressiveImage src={src} placeholder={small}>
    {(src: string) => (
      <ImageSrcSet src={new URL(src, window.location.toString()).pathname} aspect={aspect} alt={alt} css={css} />
    )}
  </ProgressiveImage>
)

export default ImageSrcSet
